/**

# RichText - Éditeur de texte riche avec SlateJS

Composant d'édition de texte riche basé sur SlateJS, 
remplaçant l'ancienne implémentation DraftJS.



## Organisation du code

1. **RichText** charge SlateJS dans un Card Ant Design, avec des boutons **RichTextButton**
2. **SlateJS** fait appel à **RichTextElement** et **RichTextLeaf** pour assurer le rendu des éléments de type bloc et inline
3. Pour le rendu du code, **RichTextElement** délègue à **CodeMirrorEditor** le rendu
4. **CodeMirrorEditor** fait une instance dynamique de **CodeMirrorBase**, qui lui affiche statiquement le code. 
   Ce dernier composant est d'ailleurs conçu pour être utilisé côté apprenant pour afficher le code sans éditeur.
5. Les fonctions utilitaires qui peuvent alourdir la lecture du code sont rangées dans **utils.ts**
6. **serializer.ts** met à disosition des fonctions de conversion markdown <=> SlateJS


## Problèmes connus

- fonctionnalités manquantes : 
  * listes imbriquées
  * code inline géré, mais pas de bouton pour en créer
  * redimensionnement des images
- boutons actifs/inactifs quand le curseur est dans un bloc CodeMirror


## Briefs "crash test"

- https://simplonline.co/trainer-workspace/briefs/f0a2fa10-c8d5-4107-8606-b598c8ae767f


*/

import RichText from "./RichText";
import RichTextRenderer from "./RichTextRenderer";
export { RichText, RichTextRenderer };
export { HtmlRichText } from "./HtmlRichText";
export { HtmlRichTextRenderer } from "./HtmlRichTextRenderer";
export { deserializeHtmlToRichTextDocument, serializeRichTextDocumentToHtml } from "./editor/htmlSerializer";
export { isRichTextDocumentEmpty } from "./editor/serializer";

export type { RichTextDocument } from "./RichText";
export default RichText;
